import React from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import { PUBLIC_URL } from './config/settings/environment'
import routes from './config/settings/routes'
import CallbackPage from './pages/Callback'
import EnrollmentCertificatePage from './pages/EnrollmentCertificate'
import HistoricalContractPage from './pages/HistoricalContract'
import HistoricalSanctionsListPage from './pages/HistoricalSanctionsList'
import NotFoundPage from './pages/NotFound'
import RegisterSanctionPage from './pages/RegisterSanction'
import SanctionDetailsPage from './pages/SanctionDetails'
import SellerCardPage from './pages/SellerCard'
import MiddlewarePage from './pages/MiddlewareRoute'

/**
 * The Routing component.
 */
const Routing = () => (
  <BrowserRouter basename={PUBLIC_URL}>
    <Routes>
      <Route caseSensitive element={<CallbackPage />} path={routes.callback} />
      <Route caseSensitive element={<EnrollmentCertificatePage />} path={routes.enrollmentCertificateBySeller} />
      <Route caseSensitive element={<EnrollmentCertificatePage />} path={routes.enrollmentCertificateByTender} />
      <Route caseSensitive element={<HistoricalContractPage />} path={routes.historicalContract} />
      <Route caseSensitive element={<HistoricalSanctionsListPage />} path={routes.historicalSanctionsList} />
      <Route caseSensitive element={<RegisterSanctionPage />} path={routes.registerSanction} />
      <Route caseSensitive element={<SanctionDetailsPage />} path={routes.sanctionDetails} />
      <Route caseSensitive element={<SellerCardPage />} path={routes.ability} />
      <Route caseSensitive element={<SellerCardPage />} path={routes.contractualBehavior} />
      <Route caseSensitive element={<SellerCardPage />} path={routes.documents} />
      <Route caseSensitive element={<SellerCardPage />} path={routes.generalInformation} />
      <Route caseSensitive element={<SellerCardPage />} path={routes.sellerCard} />
      <Route caseSensitive element={<SellerCardPage />} path={routes.suitability} />
      <Route caseSensitive element={<SellerCardPage />} path={routes.temporaryUnions} />
      <Route caseSensitive element={<SellerCardPage />} path={routes.workRegister} />
      {/* Before acces the not found page, should enter the middleware */}
      <Route element={<MiddlewarePage />} path="/*" />
      <Route element={<NotFoundPage />} path="*" />
      <Route element={<NotFoundPage />} path={routes.notFound} />
    </Routes>
  </BrowserRouter>
)

export default Routing
